import React, { useState } from 'react';
import Navbar from '../components/Navbar';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: 'matrimony',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="pi">
      <Navbar module={null} />

      <div className="sh">
        <span className="ey ey-r">✦ Partner Office Directory ✦</span>
        <h1>Get in Touch with <em>Our Team</em></h1>
        <p>
          Shared Head Office: <strong>Yogikuti Chowk, Butwal-10, Lumbini, Nepal</strong>. Serving <strong>vivahnepal.com</strong> and <strong>sabitricatering.com</strong>.
        </p>
      </div>

      <div className="sec" style={{ maxWidth: '1120px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '2.5rem',
          alignItems: 'start'
        }}>
          {/* Left Column: Contact Cards for Both Businesses & Consultant */}
          <div>
            {/* Vivah Nepal Agency Card */}
            <div className="card card-lg" style={{ marginBottom: '1.5rem', borderLeft: '4px solid var(--rose)' }}>
              <span className="tag" style={{ background: 'var(--rose-l)', color: 'var(--rose-d)', marginBottom: '0.5rem' }}>
                Vivah Nepal Matrimonial Agency (vivahnepal.com)
              </span>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.6rem', fontWeight: 700, margin: '0.2rem 0' }}>
                Laxmikant Timilsina (Owner)
              </h3>
              <div style={{ fontSize: '0.86rem', color: 'var(--mid)', lineHeight: 1.65, margin: '0.5rem 0' }}>
                📍 <strong>Residence:</strong> Tansen-09, Palpa, Nepal <br />
                📞 <strong>Direct Phone & QR:</strong> <a href="tel:9857074103" style={{ color: 'var(--rose)', fontWeight: 700 }}>9857074103</a> <br />
                💬 <strong>WhatsApp QR Payment:</strong> 9857074103 (Laxmikant Timilsina)
              </div>
            </div>

            {/* Sabitri Catering Card */}
            <div className="card card-lg" style={{ marginBottom: '1.5rem', borderLeft: '4px solid var(--gold)' }}>
              <span className="tag" style={{ background: 'var(--gold-l)', color: 'var(--gold-d)', marginBottom: '0.5rem' }}>
                Sabitri Catering and Tent House (sabitricatering.com)
              </span>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.6rem', fontWeight: 700, margin: '0.2rem 0' }}>
                Krishna Khanal (Owner)
              </h3>
              <div style={{ fontSize: '0.86rem', color: 'var(--mid)', lineHeight: 1.65, margin: '0.5rem 0' }}>
                📍 <strong>Residence:</strong> Tansen-09, Palpa, Nepal <br />
                🏢 <strong>Shared Office:</strong> Yogikuti Chowk, Butwal-10, Lumbini <br />
                📞 <strong>Direct Phone:</strong> <a href="tel:9867155395" style={{ color: 'var(--gold-d)', fontWeight: 700 }}>9867155395</a>
              </div>
            </div>

            {/* Technical Consultant Card */}
            <div className="card card-lg" style={{ borderLeft: '4px solid #2E7D32' }}>
              <span className="tag" style={{ background: '#E8F5E9', color: '#2E7D32', marginBottom: '0.5rem' }}>
                Technical Advisory & Cloud Architecture
              </span>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.5rem', fontWeight: 700, margin: '0.2rem 0' }}>
                Prakash Sharma Timilsina
              </h3>
              <div style={{ fontSize: '0.84rem', color: 'var(--mid)', lineHeight: 1.6 }}>
                💻 <strong>Role:</strong> Lead Technical Consultant & Digital Architect for Python Django, React & GCP Cloud Infrastructure. <br />
                🌐 <strong>Portfolio:</strong> <a href="https://pourkas.org" target="_blank" rel="noopener noreferrer" style={{ color: '#2E7D32', fontWeight: 700, textDecoration: 'underline' }}>pourkas.org</a>
              </div>
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div className="card card-lg">
            <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.6rem', fontWeight: 700, marginBottom: '1.2rem' }}>
              Send an Inquiry to Partners
            </h3>

            {submitted ? (
              <div className="al al-ok">
                <strong>✓ Message Sent Successfully!</strong>
                <p style={{ fontSize: '0.84rem', marginTop: '0.4rem' }}>
                  Thank you! Your message has been routed to Laxmikant Timilsina, Krishna Khanal, and technical advisory team. We will contact you shortly.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="fg">
                  <label>Your Full Name</label>
                  <input
                    type="text"
                    placeholder="e.g. Ramesh Sharma"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                  />
                </div>

                <div className="g2">
                  <div className="fg">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      placeholder="e.g. 9841234567"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      required
                    />
                  </div>
                  <div className="fg">
                    <label>Service / Partner</label>
                    <select
                      value={formData.service}
                      onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                    >
                      <option value="matrimony">Vivah Nepal Matrimony (Laxmikant T. - 9857074103)</option>
                      <option value="catering">Sabitri Catering & Decor (Krishna K. - 9867155395)</option>
                      <option value="technical">Technical Advisory (Pourkas)</option>
                      <option value="other">General Partnership Inquiry</option>
                    </select>
                  </div>
                </div>

                <div className="fg">
                  <label>Message / Event Details</label>
                  <textarea
                    placeholder="Describe your matchmaking requirements, catering menu questions, or event dates..."
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-rose btn-blk">
                  Send Message to Partners →
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
